import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { KenoBalance } from '../keno/VCredit';
import { KENO_API, gameHeaders } from '../keno/fairnessApi';
import { AccountWalletDialog } from '../account/AccountWalletDialog';

export const MobileAccountWallet = () => {
  const [wallet, setWallet] = useState(null), [error, setError] = useState(false), [open, setOpen] = useState(false);
  useEffect(() => {
    const controller = new AbortController();
    let fetching = false;
    const load = async () => {
      if (fetching || controller.signal.aborted) return;
      fetching = true;
      try {
        const { data } = await axios.get(`${KENO_API}/keno/wallet`, { headers: { ...gameHeaders(false), 'X-GV-Real-Wallet': 'true' }, signal: controller.signal, timeout: 15000 });
        if (!controller.signal.aborted) {
          setWallet((current) => !current || data.revision >= current.revision ? data : current);
          setError(false);
        }
      } catch (failure) { if (!axios.isCancel(failure)) setError(true); }
      finally { fetching = false; }
    };
    load();
    const timer = setInterval(() => { if (!document.hidden) load(); }, 5000);
    window.addEventListener('gv-wallet-updated', load);
    window.addEventListener('focus', load);
    return () => { controller.abort(); clearInterval(timer); window.removeEventListener('gv-wallet-updated', load); window.removeEventListener('focus', load); };
  }, []);
  return <>
    <div className="header-game-balance mobile-account-wallet" data-testid="mobile-account-wallet"><KenoBalance wallet={wallet} demo={false} loading={!wallet && !error} error={error} onWallet={() => setOpen(true)} /></div>
    {open && <AccountWalletDialog onClose={() => setOpen(false)} />}
  </>;
};